import { render, staticRenderFns } from "./safety.vue?vue&type=template&id=065d1da8&scoped=true"
import script from "./safety.vue?vue&type=script&lang=js"
export * from "./safety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065d1da8",
  null
  
)

export default component.exports